// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3BVRQ","inner":"Form_inner__3ZPsv","range":"Form_range__1_Va6","name":"Form_name__1RcGU","actions":"Form_actions__1dkBD"};